/**
 * Created by Zac on 9/03/2016.
 */
import Cookies from 'js-cookie';

export function SASubjectiveFeedbackHandler(feedbackButton, parentDiv) {
  const correctDiv = parentDiv.children('.Feedback.alert-success');
  const inCorrectDiv = parentDiv.children('.Feedback.alert-error');
  let correct = false;

  if (correctDiv.data('values') === parseInt(correctDiv.data('values'), 10)) {
    var correctOptions = [];
    correctOptions[0] = correctDiv.data('values');
  } else {
    var correctOptions = correctDiv.data('values').replace(' ,', ',').replace(' , ', ',').replace(', ', ',').split(',');
  }


  if (inCorrectDiv.data('values') === parseInt(inCorrectDiv.data('values'), 10)) {
    var inCorrectOptions = [];
    inCorrectOptions[0] = inCorrectDiv.data('values');
  } else {
    var inCorrectOptions = inCorrectDiv.data('values').replace(' ,', ',').replace(' , ', ',').replace(', ', ',').split(',');
  }

  function removeSpaces(array) {
    const final = [];
    for (const i in array) {
      if (array[i] != '' && array[i] != ' ') final.push(array[i]);
    }
    return final;
  }
  var correctOptions = removeSpaces(correctOptions); // Remove the spaces
  var inCorrectOptions = removeSpaces(inCorrectOptions);


  // Now we check the response
  const id = feedbackButton.attr('id').replace('shortAnswer-feedback-button', ''); // The actual activity id
  let response;

  if ($(`#Answer${id}`).html() && $(`#Answer${id}`).html().length > 0) {
    response = $(`#Answer${id}`).html();
  } else {
    response = $(`#Answer${id}`).val();
  }
  if (response != undefined) {
    for (var i in correctOptions) {
      if (response.match(new RegExp(`\\b${correctOptions[i]}\\b`))) correct = true;
    }

    for (var i in inCorrectOptions) {
      if (response.match(new RegExp(`\\b${inCorrectOptions[i]}\\b`))) correct = false;
    }
  } else correct = false;

  if (correct) {
    correctDiv.show();
    inCorrectDiv.hide();
    feedbackButton.hide();
    if (DEBUGGING) console.log('Short answer subjective correct');
    Cookies.set('finalscore', parseInt(window.Cookies.get('fi$.conalscore')) + 10, { expires: 7, path: '/' }); // Reset the cookie score
  } else {
    correctDiv.hide();
    inCorrectDiv.show();
    feedbackButton.html('Try again');
    feedbackButton.addClass('try-again');
  }


  return correct;
}



// WEBPACK FOOTER //
// Glasshouse/Core/js/activities/short-answer.js